export const FETCH_CARE_PLAN_EQUIPMENT =
  "app/CarePlanEquipment/FETCH_CARE_PLAN_EQUIPMENT";
export const FETCH_CARE_PLAN_EQUIPMENT_SUCCESS =
  "app/CarePlanEquipment/FETCH_CARE_PLAN_EQUIPMENT_SUCCESS";
export const FETCH_CARE_PLAN_EQUIPMENT_FAILURE =
  "app/CarePlanEquipment/FETCH_CARE_PLAN_EQUIPMENT_FAILURE";

// Resident-wide ACTIVE register snapshot for dedup hints (parallel slice —
// never touches the paginated `equipment` key).
export const FETCH_ACTIVE_EQUIPMENT_REGISTER =
  "app/CarePlanEquipment/FETCH_ACTIVE_EQUIPMENT_REGISTER";
export const FETCH_ACTIVE_EQUIPMENT_REGISTER_SUCCESS =
  "app/CarePlanEquipment/FETCH_ACTIVE_EQUIPMENT_REGISTER_SUCCESS";
export const FETCH_ACTIVE_EQUIPMENT_REGISTER_FAILURE =
  "app/CarePlanEquipment/FETCH_ACTIVE_EQUIPMENT_REGISTER_FAILURE";

export const FETCH_CARE_PLAN_EQUIPMENT_CATALOGUE =
  "app/CarePlanEquipment/FETCH_CARE_PLAN_EQUIPMENT_CATALOGUE";
export const FETCH_CARE_PLAN_EQUIPMENT_CATALOGUE_SUCCESS =
  "app/CarePlanEquipment/FETCH_CARE_PLAN_EQUIPMENT_CATALOGUE_SUCCESS";
export const FETCH_CARE_PLAN_EQUIPMENT_CATALOGUE_FAILURE =
  "app/CarePlanEquipment/FETCH_CARE_PLAN_EQUIPMENT_CATALOGUE_FAILURE";

export const ADD_CARE_PLAN_EQUIPMENT =
  "app/CarePlanEquipment/ADD_CARE_PLAN_EQUIPMENT";
export const ADD_CARE_PLAN_EQUIPMENT_SUCCESS =
  "app/CarePlanEquipment/ADD_CARE_PLAN_EQUIPMENT_SUCCESS";
export const ADD_CARE_PLAN_EQUIPMENT_FAILURE =
  "app/CarePlanEquipment/ADD_CARE_PLAN_EQUIPMENT_FAILURE";

export const EDIT_CARE_PLAN_EQUIPMENT =
  "app/CarePlanEquipment/EDIT_CARE_PLAN_EQUIPMENT";
export const EDIT_CARE_PLAN_EQUIPMENT_SUCCESS =
  "app/CarePlanEquipment/EDIT_CARE_PLAN_EQUIPMENT_SUCCESS";
export const EDIT_CARE_PLAN_EQUIPMENT_FAILURE =
  "app/CarePlanEquipment/EDIT_CARE_PLAN_EQUIPMENT_FAILURE";

export const DELETE_CARE_PLAN_EQUIPMENT =
  "app/CarePlanEquipment/DELETE_CARE_PLAN_EQUIPMENT";
export const DELETE_CARE_PLAN_EQUIPMENT_SUCCESS =
  "app/CarePlanEquipment/DELETE_CARE_PLAN_EQUIPMENT_SUCCESS";
export const DELETE_CARE_PLAN_EQUIPMENT_FAILURE =
  "app/CarePlanEquipment/DELETE_CARE_PLAN_EQUIPMENT_FAILURE";

export const MARK_PROVIDED_CARE_PLAN_EQUIPMENT =
  "app/CarePlanEquipment/MARK_PROVIDED_CARE_PLAN_EQUIPMENT";
export const MARK_PROVIDED_CARE_PLAN_EQUIPMENT_SUCCESS =
  "app/CarePlanEquipment/MARK_PROVIDED_CARE_PLAN_EQUIPMENT_SUCCESS";
export const MARK_PROVIDED_CARE_PLAN_EQUIPMENT_FAILURE =
  "app/CarePlanEquipment/MARK_PROVIDED_CARE_PLAN_EQUIPMENT_FAILURE";

export const MARK_DISCONTINUED_CARE_PLAN_EQUIPMENT =
  "app/CarePlanEquipment/MARK_DISCONTINUED_CARE_PLAN_EQUIPMENT";
export const MARK_DISCONTINUED_CARE_PLAN_EQUIPMENT_SUCCESS =
  "app/CarePlanEquipment/MARK_DISCONTINUED_CARE_PLAN_EQUIPMENT_SUCCESS";
export const MARK_DISCONTINUED_CARE_PLAN_EQUIPMENT_FAILURE =
  "app/CarePlanEquipment/MARK_DISCONTINUED_CARE_PLAN_EQUIPMENT_FAILURE";

export const MARK_REPLACED_CARE_PLAN_EQUIPMENT =
  "app/CarePlanEquipment/MARK_REPLACED_CARE_PLAN_EQUIPMENT";
export const MARK_REPLACED_CARE_PLAN_EQUIPMENT_SUCCESS =
  "app/CarePlanEquipment/MARK_REPLACED_CARE_PLAN_EQUIPMENT_SUCCESS";
export const MARK_REPLACED_CARE_PLAN_EQUIPMENT_FAILURE =
  "app/CarePlanEquipment/MARK_REPLACED_CARE_PLAN_EQUIPMENT_FAILURE";
